import { render, staticRenderFns } from "./CardTooDark.vue?vue&type=template&id=6a6fd482&scoped=true"
var script = {}
import style0 from "./CardTooDark.vue?vue&type=style&index=0&id=6a6fd482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fd482",
  null
  
)

export default component.exports